import styled from '@emotion/styled';
import { MDSImage } from '@marqvision/mds-v2';

const Styled = {
  VideoContainer: styled.div`
    width: 100%;
    display: grid;
    background-color: ${({ theme }) => theme.color.bg.surface.inverse.dark};
  `,
};

type Props = {
  url: string;
};

export const VideoImageContent = (props: Props) => {
  const { url } = props;

  const isVideo = isVideoExtension(url);

  if (isVideo)
    return (
      <Styled.VideoContainer>
        <video controls src={url} width="100%" />
      </Styled.VideoContainer>
    );
  return <MDSImage removeBorderRadius width="100%" height="349px" src={url} />;
};

const isVideoExtension = (url: string) => {
  const videoExtensions = ['mp4', 'webm', 'ogg', 'mov', 'avi', 'mkv', 'flv', 'wmv', 'm4v', '3gp', 'ts'];
  return videoExtensions.some((ext) => new URL(url).pathname.endsWith(ext));
};
